import type { AxiosError } from "axios"
import requests from "@/services/requests"
import { TResponse } from "@pamf-my/types"

interface Body {
  accountProductCode: string
  transactional: boolean
}

type Response = TResponse<Body>

const SAccountAuthorize = async (body: Body) => {
  const token = localStorage.getItem("token")

  try {
    const { data } = await requests.post<Response>(
      "/account/authorization/change",
      body,
      {
        headers: {
          Authorization: token ? `Bearer ${token}` : undefined,
        },
      }
    )

    return data
  } catch (error) {
    return (error as AxiosError).response?.data as Response
  }
}

export default SAccountAuthorize
